module.exports = __webpack_public_path__ + "ads.txt";


//////////////////
// WEBPACK FOOTER
// ./ads.txt
// module id = 714
// module chunks = 7